import { readStoredActiveFirmName } from '../auth/active-firm.ts';
import { readPersistedAuthenticatedUserId } from '../auth/persisted-authenticated-session.ts';

// The firm brand while the app loads: the firm the signed-in person last worked
// in, or nothing, so a firm never flashes the platform name before its own.
export default function FirmBrand() {
  const userId = readPersistedAuthenticatedUserId();
  const firmName = userId ? readStoredActiveFirmName(userId) : null;
  return <span className="application-loading-placeholder__brand">{firmName}</span>;
}
